import { FormProvider, useForm } from "react-hook-form";
import {
  SUBSCRIPTIONS_TYPES_VALUE_PER_CUSTOMER,
  SUBSCRIPTIONS_TYPES_VALUE_PER_HOLDER,
} from "../../../../../constants/subscriptions";

export function getSubscriptionSelectFormID({ subscription }) {
  return `subscription-select-form-${subscription.id}`;
}

/**
 * @typedef {object} SubscriptionCardFieldValues
 * @property {string} subscription_id
 * @property {string[]} holder_id
 */

/**
 * @param {object} params
 * @param {import("@raiden/library/types/Subscription").Subscription} params.subscription
 * @param {string[]} params.initialHolderIds
 *
 * @returns {SubscriptionCardFieldValues}
 */
function getDefaultValues({ subscription, initialHolderIds }) {
  return {
    subscription_id: String(subscription.id),
    holder_id: initialHolderIds,
  };
}

/**
 * @typedef {Object} Props
 * @property {import("@raiden/library/types/Subscription").Subscription} subscription
 * @property {string[]} initialHolderIds
 * @property {(param0: { subscriptionId: string; holderIds: string[] }) => void} upsertSubscriptionData
 * @property {(param0: { subscriptionId: string }) => void} deleteSubscriptionData
 * @property {() => void} onClose
 * @property {(params: {
 * isLoading: boolean,
 * form: import("react-hook-form").UseFormReturn<any>,
 * }) => import("react").ReactElement} render
 *
 * @param {Props} props
 */
function Handler({
  subscription,
  initialHolderIds,
  deleteSubscriptionData,
  upsertSubscriptionData,
  onClose,
  render,
}) {
  const form = useForm({
    defaultValues: getDefaultValues({
      subscription,
      initialHolderIds: initialHolderIds,
    }),
  });
  const { handleSubmit } = form;

  /**
   * @param {SubscriptionCardFieldValues} values
   */
  function onSubmit(values) {
    switch (subscription.type) {
      case SUBSCRIPTIONS_TYPES_VALUE_PER_CUSTOMER:
        upsertSubscriptionData({
          subscriptionId: values.subscription_id,
          holderIds: values.holder_id,
        });
        break;
      case SUBSCRIPTIONS_TYPES_VALUE_PER_HOLDER:
        if (values.holder_id.length === 0) {
          deleteSubscriptionData({
            subscriptionId: values.subscription_id,
          });
        } else {
          upsertSubscriptionData({
            subscriptionId: values.subscription_id,
            holderIds: values.holder_id,
          });
        }
        break;
    }
    onClose();
  }

  return (
    <FormProvider {...form}>
      <form
        id={getSubscriptionSelectFormID({ subscription })}
        onSubmit={handleSubmit(onSubmit)}>
        {render({
          form,
          isLoading: false,
        })}
      </form>
    </FormProvider>
  );
}

export default Handler;
